import { ChangeDetectorRef, Component, Input, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { AoiService } from '../../../services/aoi.service';
import { GisToolsService } from '../../../services/gis-tools.service';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-interstate',
    templateUrl: './interstate.component.html',
    styleUrls: ['../../sharedStyles/base.scss', './interstate.component.scss']
})
export class InterstateComponent extends BaseComponent {
    routes: any[];
    interstates: string[];

    isActive: boolean;

    private _interstate: string;
    set interstate(route: string) {
        this._interstate = route;
    }
    get interstate() {
        return this._interstate;
    }

    constructor(
        _vcr: ViewContainerRef,
        private readonly gisToolsService: GisToolsService,
        private readonly aoiService: AoiService,
        private readonly cdr: ChangeDetectorRef
    ) {
        super(_vcr, true);
    }

    @Input()
    public activate = async () => {
        if (this.isActive) { return; }

        try {
            this.routes = await this.gisToolsService.getInterstatesByNetworkIndicator();

            this.interstates = [];
            for (const route of this.routes) {
                const routeNumber = route.stateRouteNumber.replace(/^0+/, ''); // remove leading 0s

                if (!this.interstates.includes(routeNumber)) { // filter list to distinct routeNumbers
                    this.interstates.push(routeNumber);
                }
            }

            this.cdr.detectChanges();
        } catch (error) {
            this.readyProblem(error);
        } finally {
            this.isReady();
            this.isActive = true;
        }
    }

    @Input()
    public reset = () => {
        this._interstate = null;
    }

    @Input()
    public addResultToMap = () => {
        let routeNumber: string = this.interstate;
        if (routeNumber.length === 2) {
            routeNumber = '00' + routeNumber;
        } else if (routeNumber.length === 3) {
            routeNumber = '0' + routeNumber;
        }

        const searchCriteria: any = {
            type: 'route',
            title: `Route (${routeNumber})`,
            stateRouteNumber: routeNumber
        };

        this.aoiService.setSearchCriterias([searchCriteria]);
    }

}
